var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{staticClass:"header__logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/images/logo-y.svg","alt":"DeNA AI"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }